import { ButtonBase, styled } from "@material-ui/core";

// styled("div") em vez de styled(Box): o Box do Material-UI v4 recalcula
// estilos por instância em runtime (JSS dinâmico), o que travava a montagem
// da lista de cards. Com div os estilos viram classes estáticas compartilhadas.

export const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  paddingTop: "18px"
});

export const TitleRow = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px"
});

export const PageTitle = styled("h1")({
  margin: 0,
  fontSize: "20px",
  fontWeight: 400,
  color: "#5f5f5f"
});

export const CountLabel = styled("div")({
  fontSize: "13px",
  color: "#9e9e9e",
  whiteSpace: "nowrap",
  textAlign: "right"
});

export const SearchCard = styled("div")({
  background: "#fff",
  borderRadius: "8px",
  boxShadow: "0 1px 6px rgba(0,0,0,.08)",
  padding: "14px"
});

export const SearchField = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  background: "#fff",
  border: "1px solid #C4C4C4",
  borderRadius: "4px",
  padding: "0 12px",
  height: "52px",
  "&:focus-within": {
    borderColor: "#416D0B"
  }
});

export const CardList = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  paddingTop: "12px"
});

export const CardItem = styled("div")({
  background: "#fff",
  borderRadius: "8px",
  boxShadow: "0 1px 6px rgba(0,0,0,.08)",
  overflow: "hidden",
  // Deixa o browser pular o layout/paint dos cards fora da viewport.
  contentVisibility: "auto",
  containIntrinsicSize: "0 130px"
});

export const CardTop = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "12px",
  padding: "14px 14px 12px"
});

export const CardInfo = styled("div")({
  minWidth: 0,
  flex: 1
});

export const ProductName = styled("div")({
  fontSize: "15px",
  fontWeight: 500,
  color: "#3f3f3f",
  lineHeight: 1.35
});

export const ChipRow = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  marginTop: "7px",
  flexWrap: "wrap"
});

export const IdChip = styled("span")({
  fontSize: "11.5px",
  fontWeight: 500,
  color: "#5f7a2a",
  background: "#F3F8E6",
  borderRadius: "4px",
  padding: "3px 8px"
});

export const TypeChip = styled("span")({
  fontSize: "11.5px",
  color: "#757575",
  background: "#f4f4f4",
  borderRadius: "4px",
  padding: "3px 8px"
});

export const StockBlock = styled("div")({
  textAlign: "right",
  flex: "0 0 auto",
  paddingLeft: "4px"
});

export const SmallLabel = styled("div")({
  fontSize: "11px",
  color: "#9e9e9e",
  lineHeight: 1.2
});

export const StockValue = styled("div")({
  fontSize: "24px",
  fontWeight: 500,
  lineHeight: 1.2,
  fontVariantNumeric: "tabular-nums"
});

export const FooterGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  borderTop: "1px solid #f0f0f0",
  background: "#fcfcfc"
});

export const FooterCell = styled("div")({
  padding: "10px 14px",
  display: "flex",
  flexDirection: "column",
  "&:first-child": {
    borderRight: "1px solid #f0f0f0"
  }
});

export const FooterRow = styled("div")({
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
  gap: "12px",
  padding: "10px 14px",
  borderTop: "1px solid #f0f0f0",
  background: "#fcfcfc"
});

export const FooterLabel = styled("div")({
  fontSize: "11px",
  color: "#9e9e9e",
  lineHeight: 1.3
});

export const FooterCellLabel = styled(FooterLabel)({
  minHeight: "29px"
});

export const FooterValue = styled("div")({
  fontSize: "14px",
  fontWeight: 500,
  color: "#3f3f3f",
  fontVariantNumeric: "tabular-nums",
  marginTop: "2px"
});

export const LoadMoreButton = styled(ButtonBase)({
  background: "#fff",
  borderRadius: "8px",
  boxShadow: "0 1px 6px rgba(0,0,0,.08)",
  padding: "14px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#416D0B",
  fontFamily: "inherit",
  width: "100%"
});

export const EmptyState = styled("div")({
  padding: "48px 8px",
  textAlign: "center",
  color: "#9e9e9e",
  fontSize: "14px"
});
